<!--
Copyright (c) 2020-2025 ForgeRock. All rights reserved.

This software may be modified and distributed under the terms
of the MIT license. See the LICENSE file for details.
-->

<template>
        <!-- Container style logo -->
    <div v-if="logoType === 'container' && !isAccountLinking" class="logo-div-container">
        <div class="text-center">
            <div class="logo-container" :style="logoDisplayStyle">
                <img class="main-logo side-logo" :src="logoSrc" width="212px" alt="Pearson logo" />
            </div>
            <div class="logo-text" v-if="welcomeText">
                <span>{{ welcomeText }}</span>
            </div>
        </div>
    </div>

    <div v-else-if="logoType === 'container' && isAccountLinking" class="logo-div-container-acc">
        <div>
            <div class="logo-container-acc" :style="logoDisplayStyle">
                <img class="main-logo side-logo" :src="logoSrc" width="212px" alt="Pearson logo" />
            </div>
            <div class="logo-text" v-if="welcomeText">
                <span>{{ welcomeText }}</span>
            </div>
        </div>
    </div>

    <!-- Standard single logo -->
    <div v-else-if="logoType === 'standard'"
            :class="logoContainerClass || ''"
            :id="logoId || 'themeLogo'">
        <img :src="logoSrc"
                :alt="logoAlt || 'Logo'"
                :width="logoWidth || '210px'"
                :height="logoHeight || 'auto'"
                :class="logoClass || ''" />
    </div>

    <!-- QI style multi-part logo -->
    <div v-else-if="logoType === 'composite'"
            :class="logoContainerClass || ''"
            :id="logoId || 'compositeLogo'">
        <img v-for="(imagePart, index) in logoImages"
                :key="index"
                :src="imagePart.src"
                :alt="imagePart.alt"
                :width="imagePart.width"
                :height="imagePart.height"
                :class="imagePart.class" />
    </div>
     <div v-else-if="logoType === 'gedImage'" class="ged-logo-div-container">
        <div class="ged-logo-div">
            <div class="ged-logo-container" :style="logoDisplayStyle">
                <img class="main-logo side-logo" :src="logoSrc" :width="logoWidth" :alt="logoAlt" />
            <div class="logo-text">
                <p class="ged-welcome-text">{{ $t('pages.selfservice.registration.gedManagerWelcomeText')}}</p>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { isLogoDisplayed } from '../../../lib/logoHelper';

/**
 * @description Pearson Logo component for use across various pages
 */
export default {
    name: 'PearsonLogo',
    props: {
        logoType: {
            type: String,
            default: 'container',
            validator: function (value) {
                return ['container', 'standard', 'composite', 'none', 'gedImage'].includes(value);
            }
        },
        logoSrc: {
            type: String,
            default: null
        },
        logoAlt: {
            type: String,
            default: 'Logo'
        },
        logoWidth: {
            type: String,
            default: '210px'
        },
        logoHeight: {
            type: String,
            default: 'auto'
        },
        logoClass: {
            type: String,
            default: ''
        },
        logoId: {
            type: String,
            default: 'themeLogo'
        },
        logoContainerClass: {
            type: String,
            default: ''
        },
        logoImages: {
            type: Array,
            default: () => []
        },
        welcomeText: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            isAccountLinking: this.getQueryStringValue('isLinkingAccounts') === 'true'
        };
    },
    computed: {
        logoDisplayStyle () {
            return isLogoDisplayed() ? '' : 'display: none;';
        }
    },
    methods: {
        getQueryStringValue (name) {
            let url = decodeURIComponent(window.location.href);
            name = name.replace(/[[]/, '\\["').replace(/[\]]/, '\\]');
            let regexS = '[\\?&]' + name + '=([^&#]*)';
            let regex = new RegExp(regexS);
            let results = regex.exec(url);
            return results == null ? null : results[1];
        }
    }
};
</script>

<style scoped lang="scss">
/* Styles are imported from pearson-common.css at the page level */
</style>
